import { 
    LOGOUT, 
    ResponseData, 
    LOGOUT_KEEP_DATA,
    LOGIN_AS_ADMIN,
    LOGIN_WITH_USERNAME_PASSWORD,
    LOGIN_WITH_USERNAME_PASSWORD_ERROR,
    SET_LOADING,
    TOGGLE_ADMIN,
    TOGGLE_AUTH_MODAL,
} from './types';
import AxiosConfig from '../../utilities/AxiosConfig';
import axios from 'axios';
import qs from 'querystring-es3';
import msalAuth from '../../utilities/msalAuth';
import logger from '../../utilities/logging';
import store from '../store';

export const loginRememberedUser = (data : ResponseData, shouldRemember : boolean, cb? : Function, errorCallback? : Function) => (dispatch: any) => {
    AxiosConfig.setupConfig(data.token_type, data.access_token, "");
    let parsedRoles:Array<string> = data.roles.split(",");
    if(shouldRemember){
        setLocalStorageAuth(data);
    }else{
        localStorage.removeItem("shouldRemember");
    }
    axios.get(process.env.REACT_APP_API_URL + "/api/settings", AxiosConfig.configValue())
    .then(response => {
        let settings = response.data;
        dispatch({
            type : LOGIN_WITH_USERNAME_PASSWORD, 
            payload : {
                access_token : data.access_token,
                token_type : data.token_type,
                expires_in : data.expires_in,
                userName : data.userName,
                '.issued' : data[".issued"],
                '.expires' : data[".expires"],
                roles : parsedRoles,
                PortalSettings : settings.PortalSettings,
                UserSettings : settings.UserSetttings,
                homeProfitCenter: data.homeProfitCenter
            }
        });
        cb&&cb();
        // Notifications call
        // axios.get(`process.env.REACT_APP_API_URL/api/User/Notifications?userId=${data.userId}&category=reference`)
        // axios.get(`process.env.REACT_APP_API_URL/api/User/Notifications?userId=${data.userId}&category=release`)
        // .then((response: any) => {
        //     //console.log("Get notifications call");
        //     //console.log(response, response.data);
        // })
        // .catch((error: any) => {
        //     //console.log("Get notifications call error");
        //     //console.log(error, error.response);
        // })
    })
    .catch(error => {
        //console.log(error, error.response);
        // error callback
        alert("There was an error retrieveing User and Portal settings.")
        dispatch({ type : LOGOUT });
        logger.Error({
            EventMessage : "user/actions.tsx -> loginRememberedUser -> catch error" + JSON.stringify(error.response),
            EventCategory : "httpresponse"
        });
        AxiosConfig.handleError(error.response.status);
        if(errorCallback){
            errorCallback();
        }
    })
}

export const loginWithUsernameAndPassword = (username : string, password : string | null, shouldRemember : boolean, cb? : Function) => (dispatch : any):any => {
    dispatch({ type: SET_LOADING, payload : true });
    let data:any = {};
    if(username.length){
        const config = {
            headers : {
                'content-type' : 'application/x-www-form-urlencoded'
            }
        };
        const requestBody = {
            userName : username,
            password : password,
            grant_type : "password",
            client_id : process.env.REACT_APP_CLIENT_ID,
        }

        //console.log("Request Body", requestBody);

        axios.post(`${process.env.REACT_APP_API_URL}/token`, qs.stringify(requestBody), config)
        .then(res => {
            data = res.data;
            //console.log("loginWithUsernamePassword", data);
            AxiosConfig.setupConfig(data.token_type, data.access_token, data.sessionKey);
            let parsedRoles:Array<string> = data.roles.split(",");
            if(shouldRemember){
                setLocalStorageAuth(data);
            }else{
                localStorage.removeItem("shouldRemember");
            }
            //console.log("Getting Settings");
            axios.get(process.env.REACT_APP_API_URL + "/api/settings", AxiosConfig.configValue())
            .then(response => {
                const settings = response.data;
                dispatch({
                    type : LOGIN_WITH_USERNAME_PASSWORD, 
                    payload : {
                        access_token : data.access_token,
                        token_type : data.token_type,
                        expires_in : data.expires_in,
                        userName : data.userName,
                        '.issued' : data[".issued"],
                        '.expires' : data[".expires"],
                        roles : parsedRoles,
                        PortalSettings : settings.PortalSettings,
                        UserSettings : settings.UserSetttings,
                        userId : data.userId,
                        homeProfitCenter: data.homeProfitCenter
                    }
                });
                //console.log("CALLING NOTIFICATIONS")
                // Notifications call
                // axios.get(`process.env.REACT_APP_API_URL/api/User/Notifications?userId=${data.userId}&category=reference`)
                // axios.get(`process.env.REACT_APP_API_URL/api/User/Notifications?userId=${data.userId}&category=release`)
                // .then((response: any) => {
                //     //console.log("Get notifications call");
                //     //console.log(response, response.data);
                // })
                // .catch((error: any) => {
                //     //console.log("Get notifications call error");
                //     //console.log(error, error.response);
                // })
                cb&&cb();
            })
            .catch(error => {
                //console.log(error, error.response);
                dispatch({ type : LOGIN_WITH_USERNAME_PASSWORD_ERROR, payload : "There was a problem getting Portal and User settings."})
            })
        })
        .catch((err) => {
            //console.log("Login Error", err);
            //console.log(err.response, err.response);
            dispatch({ type : LOGIN_WITH_USERNAME_PASSWORD_ERROR, payload : "There was a problem logging you in."})
        })
    }
}

export const logout = () => {
    const requestBody = {};
    axios.get(process.env.REACT_APP_API_URL + "/api/User/sessioninactive/set", AxiosConfig.configValue("min"))
    .then(res => {
        //console.log("Session Inactive Set", res);
        axios.post(process.env.REACT_APP_API_URL + "/api/user/signout", requestBody, AxiosConfig.configValue())
        // .then(response => {
        //     //console.log("LOGOUT", response, response.data);
        //     msalAuth.logout();
        // })
        // .catch(error => {
        //     //console.log(error, error.response, error.response.data);
        //     logger.Error({
        //         EventMessage : `user/actions.tsx --> logout -> Error : ${JSON.stringify(error)}`,
        //         EventCategory : "httprequest"
        //     });
        // })  
    })
    .catch(err => {
        //console.log(err, err.response);
    })
    clearLocalStorageAuth();
    localStorage.removeItem("shouldRemember");
    localStorage.removeItem("qbCode");
    localStorage.removeItem("qbRealmId");
    return { type : LOGOUT };
}

export const logoutKeepData = () => {
    return { type : LOGOUT_KEEP_DATA };
}

export const loginAsAdmin = (data: ResponseData) => {
    logger.Info({
        EventMessage : "Login as Admin Called. USERID ->" + data.userId,
        EventCategory : "admin-login"
    });
    return { type : LOGIN_AS_ADMIN, payload : data };
}

export const setLoading = (isLoading : boolean) => {
    return isLoading;
}

export const toggleAdmin = () => {
    logger.Info({
        EventMessage : "Toggle Admin Called. USERID ->" + store?.getState()?.user?.userId,
        EventCategory : "admin-toggle"
    });
    return { type: TOGGLE_ADMIN };
}

const clearLocalStorageAuth = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("token_type");
    localStorage.removeItem("userName");
    localStorage.removeItem("expires_in");
    localStorage.removeItem("expires");
    localStorage.removeItem("issued");
    localStorage.removeItem("shouldRemember");
    localStorage.removeItem("roles");
    localStorage.removeItem("qbCode");
    localStorage.removeItem("qbRealmId");
    localStorage.removeItem("qbAccessToken");
    localStorage.removeItem("qbRefreshToken");
    localStorage.removeItem("qbExpires");
}

const setLocalStorageAuth = (data: ResponseData) => {
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("token_type", data.token_type);
    localStorage.setItem("userName", data.userName);
    localStorage.setItem("expires_in", data.expires_in.toString());
    localStorage.setItem("expires", data[".expires"].toString());
    localStorage.setItem("issued", data[".issued"].toString());
    localStorage.setItem("shouldRemember", "true");
    localStorage.setItem("roles", data.roles.toString());
}

export const toggleAuthModal = (shouldOpen: boolean) => ({ type: TOGGLE_AUTH_MODAL, payload: shouldOpen });

export const addFavoriteFilter = (config: {moduleName: string, favoriteName: string, url: string, category: string, filters: any}) => (dispatch: any) => {
    let original: any = {...store.getState().user.UserSettings};
    if(original.SavedFilters){
        original.SavedFilters[config.moduleName] = {...original.SavedFilters[config.moduleName], [config.favoriteName]: config.filters}
    }else{
        original.SavedFilters = {};
        original.SavedFilters[config.moduleName] = {};
        original.SavedFilters[config.moduleName][config.favoriteName] = config.filters;
    }
    const favoriteData: MetaData = {
        url: config.url,
        name: config.favoriteName,
        category: config.category,
        hasFilter: true
    };
    if(original.Favorites){
        if(!original.Favorites[config.category]){ original.Favorites[config.category] = []; }
        const foundIndex: number = original.Favorites[config.category].findIndex((fav: MetaData) => fav.name === config.favoriteName)
        if(foundIndex >= 0){
            original.Favorites[config.category].slice(foundIndex, 1, favoriteData);
        }else{ original.Favorites[config.category].push(favoriteData); }
    }else{
        original.Favorites = {};
        original.Favorites[config.category] = [];
        original.Favorites[config.category].push(favoriteData);
    }
    msalAuth.updateUserSettings(original);
}

export const updateUserSettings = (newUserSettings: any) => (dispatch: any) => {
    msalAuth.updateUserSettings(newUserSettings);
}

export const updateSavedFilters = (moduleName: string, filterName: string, filters: Object, shouldDelete: boolean = false) => (dispatch: any) => {
    let original: any = {...store.getState().user.UserSettings};
    let originalSavedFilters = {...original.SavedFilters};
    if(shouldDelete){
        if(originalSavedFilters){
            delete originalSavedFilters[moduleName][filterName];
            const updatedUserSettings: any = {...original, SavedFilters: originalSavedFilters};
            msalAuth.updateUserSettings(updatedUserSettings)
        }
    }else{
        if(originalSavedFilters){ //? Currently saved filters 
            const updated: any = {...originalSavedFilters[moduleName], [filterName]: filters};
            const updatedUserSettings =  { ...original, SavedFilters: {...originalSavedFilters, [moduleName]: updated} };
            //console.log("Updated User Settings: ", updatedUserSettings)
            msalAuth.updateUserSettings(updatedUserSettings);
        }else{ //? There is no saved filters yet
            const updatedUserSettings: any = {...original, SavedFilters: {
                [moduleName]: {
                    [filterName]: filters
                }
            }}
            //console.log("New User Settings: ", updatedUserSettings);
            msalAuth.updateUserSettings(updatedUserSettings)
        }
    }

}

export const clearAllSavedFilters = () => (dispatch: any) => {
    let original: any = {...store.getState().user.UserSettings};
    const updatedUserSettings =  { ...original, SavedFilters: {}, Favorites: {} };
    //console.log("Updated User Settings: ", updatedUserSettings)
    msalAuth.updateUserSettings(updatedUserSettings);
}

export interface MetaData {
    url: string;
    name: string;
    category: string;
    hasFilter: boolean;
}

export const updateFavorites = (metaData: MetaData, shouldDelete: boolean = false) => (dispatch: any) => {
    let original: any = {...store.getState().user.UserSettings};
    let newFavorites = {...original.Favorites};
    if(!newFavorites){
        newFavorites = {}
    }
    if(!newFavorites[metaData.category]){
        newFavorites[metaData.category] = [];
    }
    const foundIndex: number = newFavorites[metaData.category].findIndex((fav: MetaData) => fav.name === metaData.name);
    if(shouldDelete){//? Deleting a favorite
        newFavorites[metaData.category].splice(foundIndex, 1);
        //console.log("After Favorite Delete: ", newFavorites);
    }else{ //? Adding or editing a favorite
        if(foundIndex >= 0){//? Exists
            newFavorites[metaData.category].slice(foundIndex, 1, metaData);
        }else{ newFavorites[metaData.category].push(metaData); }
    }
    // //console.log("New Favorites: ", { ...original, Favorites: newFavorites });
    msalAuth.updateUserSettings({ ...original, Favorites: newFavorites });
}

export const editFavoriteName = (metaData: MetaData, newName: string) => (dispatch: any) => {
    let original: any = {...store.getState().user.UserSettings};
    let newFavorites: any = {...original.Favorites};
    //TODO: If metadata has a saved filter change filter name
    const foundIndex: number = newFavorites[metaData.category].findIndex((fav: MetaData) => fav.name === metaData.name);
    if(foundIndex >= 0){
        newFavorites[metaData.category][foundIndex].name = newName;
        if(metaData.hasFilter){
            let newSavedFilters: any = {...original.SavedFilters};
            const copy: any = {...newSavedFilters[metaData.category][metaData.name]};
            delete newSavedFilters[metaData.category][metaData.name];
            newSavedFilters[metaData.category][newName] = copy;
            msalAuth.updateUserSettings({ ...original, Favorites: newFavorites, SavedFilters: newSavedFilters })
        }else{ msalAuth.updateUserSettings({ ...original, Favorites: newFavorites }); }
    }
}